module.exports = __webpack_public_path__ + "img/V-63-ST-1000-BB.b0e70a75.png";